module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "theme-picker"
  }, _vm._l((_vm.themes), function(theme, index) {
    return _c('div', {
      key: index,
      staticClass: "swatch",
      style: ({
        backgroundColor: theme.background
      }),
      on: {
        "click": function($event) {
          return _vm.setSelectedTheme(index)
        }
      }
    }, [(index === _vm.$store.state.selectedTheme) ? _c('svg', {
      staticClass: "swatch__check",
      attrs: {
        "fill": theme.accent,
        "height": "24",
        "width": "24"
      }
    }, [_c('use', {
      attrs: {
        "href": "#iconCheckOn"
      }
    })]) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c258970","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThemePicker.vue
// module id = 134
// module chunks = 1